const cis = {
	name: 'Central Information System | Central Information Systems',
	shortcut: 'C.I.S.',
	icon: 'fa-fw fa-solid fa-comment-lines',
	fields: {
		cisType: 'C.I.S. Type',
	},
}

export default cis
